import { __assign, __rest } from "tslib";
import React from 'react';
import { Step as MaterialStep } from '@material-ui/core';
export var Step = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(MaterialStep, __assign({}, props), children);
};
//# sourceMappingURL=Step.js.map